import { useState } from "react";
import { Box, styled, Popover, Typography, List, ListItem, useTheme } from "@mui/material";
import Button from '@mui/material/Button';
import { useTaskProblemDetails } from "hooks/tasks";

const StyledPopover = styled(Popover)(() => ({
  '& .MuiPopover-paper': {
    padding: '10px',
    width:'15%'
  },
  '& .MuiBox-root': {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '10px'    
  },
  '& .MuiButton-root': {
    width: '100%'
  }
})); 

export default function TaskViewProblem({ ...props }) {
  const theme = useTheme();
  const [ data, total, loading, error ]= useTaskProblemDetails(props.TaskId);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <Button variant="outlined" aria-describedby={id} onClick={handleClick} sx={{ backgroundColor: theme.palette.primary.contrastText }}>View</Button>
      <StyledPopover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <List>
          {data.map((item: any) => (
            <ListItem key={item.id}>
              <Typography>{item.note}</Typography>
            </ListItem>            
          ))}
        </List>
        <Box>
        <Button variant="contained" onClick={handleClose}>Close</Button>
        </Box>
      </StyledPopover>
    </div>
  );
  }